export default __webpack_public_path__ + "static/media/map-cross.aa469d8a.svg";